module.exports = __webpack_public_path__ + "static/media/akansha_patil.dc09b407.png";